module.exports = __webpack_public_path__ + "img/default-account.d5059aff.svg";